import { render, staticRenderFns } from "./NewsletterEmail.vue?vue&type=template&id=39f94e23&scoped=true"
import script from "./NewsletterEmail.vue?vue&type=script&lang=js"
export * from "./NewsletterEmail.vue?vue&type=script&lang=js"
import style0 from "./NewsletterEmail.vue?vue&type=style&index=0&id=39f94e23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f94e23",
  null
  
)

export default component.exports